import { getHeaders } from "../utils";

export async function APIGetNotifications(userId) {
	try {
		const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

		const requestOptions = {
			method: 'GET',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/notifications/1.0/user/${userId}`, requestOptions);
		const responseObject = await response.json();
        const notifications = responseObject.data;

		return notifications;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APINotificationsToggle(notificationId,userId) {
	try {
		const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

		const requestOptions = {
			method: 'PUT',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/notifications/1.0/user/${userId}/notifications/${notificationId}`, requestOptions);
		const responseObject = await response.json();
        const notification = responseObject.data;
		return notification;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APINotificationsReadAll(userId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'PUT',
            headers: headers,
            redirect: 'follow'
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/notifications/1.0/user/${userId}/notifications/all/read`, requestOptions);
        const responseObject = await response.json();
        const notifications = responseObject.data;
        return notifications;

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APINotidicationDeleteAll(userId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'DELETE',
            headers: headers,
            redirect: 'follow'
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/notifications/1.0/user/${userId}/notifications/all/delete`, requestOptions);
        const responseObject = await response.json();
        const notifications = responseObject.data;
        return notifications;

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APINotificationsDelete(notificationId,userId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'DELETE',
            headers: headers,
            redirect: 'follow'
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/notifications/1.0/user/${userId}/notifications/${notificationId}`, requestOptions);
        const responseText = await response.json();
        return await responseText.rows;

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIGetUnreadNotificationsCount(userId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/notifications/1.0/user/${userId}/notifications/unread`, requestOptions);
        const responseObject = await response.json();
        const count = responseObject.data;
        return count;

    } catch (error) {
        console.error('Error:', error);
        return 0;
    }
}